document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('[data-freewink-drawer-close]');
  if (!closeButton) return;

  const drawer = closeButton.closest('header-drawer');
  const summary = drawer?.querySelector('#Details-menu-drawer-container > summary');
  if (!drawer || !summary || typeof drawer.closeMenuDrawer !== 'function') return;

  drawer.closeMenuDrawer(event, summary);
});

document.addEventListener('change', (event) => {
  const toggle = event.target.closest('[data-freewink-nav-toggle]');
  if (!toggle) return;

  const label = toggle.nextElementSibling;
  if (label?.matches('label[aria-expanded]')) {
    label.setAttribute('aria-expanded', toggle.checked ? 'true' : 'false');
  }
});
